export default "__VITE_ASSET__c0264f06__"